<!--<search></search>-->

<div class="row" style="margin:10px 0px;">
  <div class="col-md-12">
    <div class="panel panel-default" style="border: none;">
      <div class="panel panel-default" style="margin-top:10px;">
        <div class="panel-heading">
          <h4 class="panel-title">
            Step #1: Select one.
          </h4>
        </div>
        <div class="panel-body text-center">
          <div class="row" style="justify-content: space-evenly; align-items: center;" *ngIf="!loading">
            <div class="col-md-6">
              <button class="btn btn-default" (click)="getActivities()">Find Activities Missing
                Results
              </button>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <input class="form-control" [(ngModel)]="labId" placeholder="Enter Lab ID"
                       style="min-width: 142px;"/>
                <span class="input-group-btn">

                            <button class="btn btn-default" (click)="getResults(labId)">Load Lab Results</button>
                                  </span>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="loading" style="justify-content: center;">
            <div class="col-md-12">
              <i class="fa fa-spinner fa-2x fa-pulse"></i>
            </div>
          </div>
          <br/>
        </div>
      </div>
      <div class="panel panel-default" style="margin-top:10px;" *ngIf="!loading">
        <div class="panel-heading">
          <div class="panel-title">
            Activities Missing Results
          </div>
        </div>
        <div class="panel-body">
          <div class="row" *ngIf="loading">
            <div class="col-md-12" style="text-align: center;">
              <i class="fa fa-pulse fa-spinner fa-2x"></i>
            </div>
          </div>
          <div class="row" *ngIf="!loading && items !== undefined && items.length === 0 ">
            <div class="col-md-12" style="text-align: center;">
              No Activities Missing Results Found.
            </div>
          </div>
          <div class="row table-responsive" *ngIf="!loading && items !== undefined">
            <table class="table table-striped">
              <thead>
              <tr>
                <ng-template ngFor let-key [ngForOf]="meta.display_fields">
                  <th>
                    {{ meta.fields[key].label }}
                  </th>

                </ng-template>
                <th>Measure</th>
                <th *ngIf="meta.fields.characteristicname === undefined">Characteristic Name</th>
              </tr>
              </thead>
              <!-- Moved ng-repeat from tbody to tr -->
              <tbody>
              <tr *ngFor="let item of items" style="border: none;"><!-- *ngIf="itemIndex = $index"-->
                <ng-template ngFor let-key [ngForOf]="meta.display_fields">
                  <td style="vertical-align: middle;">
                    <app-display-field *ngIf="key !== 'lab_date_collected'" [type]="meta.fields[key].type"
                                       [value]="item[key]"
                                       [choices]="meta.fields[key].choices"></app-display-field>
                    <span *ngIf="key === 'lab_date_collected'">{{ item[key] | date:'shortDate' }}</span>
                  </td>
                </ng-template>
                <td><input class="form-control" type="number" [(ngModel)]="item.measure"></td>
                <td><input class="form-control" type="text"
                           [(ngModel)]="item.characteristicname"/></td>
              </tr>


              </tbody>
            </table>
            <p class="text-center">
              <button class="btn btn-primary" (click)="save()" *ngIf="!saving">Save</button>
              <button class="btn btn-primary" *ngIf="saving"><i class="fa fa-spinner fa-pulse"></i></button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <script type="text/ng-template" id="warningModal.html">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Danger!</h4>
    </div>
    <div class="modal-body">
        By selecting this you will reload all of the activities and any unsaved changes will be lost.
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" (click)="ok()">Ok</button>
        <button type="button" class="btn btn-primary" (click)="cancel()">Cancel</button>
    </div>
</script> -->

